import React from "react";
import LayoutView from "../../components/layout";
import Auth from "../../hoc/Auth";
import WorkerActivityHistory from "../profile/WorkerActivityHistory";

const MyActivity = () => (
  <LayoutView activePage="My Activity">
    <WorkerActivityHistory />
  </LayoutView>
);

export default Auth(MyActivity);
